import type { FluidSharedTree } from "../../fluid/fluid.client.js";

export type UserPosition =
  | { type: "table"; locationId: string; occupantIds: string[] }
  | { type: "entrance"; locationId: "entrance"; occupantIds: string[] }
  | { type: "room"; locationId: string; occupantIds: string[] }
  | { type: "none" };

export const resolveCurrentPosition = ({
  selfUserId,
  sharedTree,
}: {
  selfUserId: string;
  sharedTree: FluidSharedTree;
}): UserPosition => {
  for (const table of sharedTree.root.tables) {
    if (table?.participants.includes(selfUserId)) {
      return {
        locationId: table.id,
        occupantIds: [...table.participants],
        type: "table",
      };
    }
  }

  if (sharedTree.root.entranceArea.users.includes(selfUserId)) {
    return {
      locationId: "entrance",
      occupantIds: [...sharedTree.root.entranceArea.users],
      type: "entrance",
    };
  }

  for (const room of sharedTree.root.rooms) {
    if (room.users.includes(selfUserId)) {
      return {
        locationId: room.id,
        occupantIds: [...room.users],
        type: "room",
      };
    }
  }

  return { type: "none" };
};
